export const DROP_SHIPMENT_ORDER_FLAG = 'drop-shipment-order'

export function isDropShipmentOrderFeatureFlagEnabled(value: unknown): boolean {
  return typeof value === 'string' && value.trim().toLowerCase() === 'enabled'
}
